import { useEffect, useState } from 'react';

import { fetchMilestoneGraphData } from 'screens/reports/crmReportsScreen/dashboardReport/actions.js';
import { format } from 'date-fns';
import selectors from 'selectors/selectors';
import { useSelector } from 'react-redux';
import { store } from 'redux/lib/configureStore';
// const startOfMonthThreeMonthsAgo = startOfMonth(subMonths(new Date(), 3));
// const lastMonth = subMonths(new Date(), 1);
// const lastDayOfLastMonth = lastDayOfMonth(lastMonth);

const useMilestoneFunnelGraph = (props) => {
  const state = store.getState();
  const { id } = props;
  const [loading, setIsLoading] = useState(false);
  const milestoneFunnelGraphData = useSelector((state) => state.reporting.milestoneFunnelGraphData);
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const filteredLocationId = useSelector(selectors.filteredLocationId);
  const filteredUserId = useSelector(selectors.filteredUserId);
  const dates = useSelector(selectors.dateRangePickerSelector);
  const reportsFilters = useSelector(selectors.reportsFilters);

  const fetchData = {
    service_provider_id: serviceProviderId,
    ...(filteredLocationId ? { service_location_id: filteredLocationId } : {}),
    ...(filteredUserId ? { user_id: filteredUserId } : {}),
    ...(id ? { pipeline_id: id } : {}),
    ...(dates ? { start_date: format(new Date(dates.startDate), 'yyyy-MM-dd') } : {}),
    ...(dates ? { end_date: format(new Date(dates.endDate), 'yyyy-MM-dd') } : {}),
    ...(reportsFilters.service_id ? { service_id: reportsFilters.service_id } : {}),
    ...(reportsFilters.utm_medium ? { utm_medium: reportsFilters.utm_medium } : {}),
  };

  useEffect(() => {
    setIsLoading(true);
    fetchMilestoneGraphData(fetchData, () => {
      setIsLoading(false);
    });
  }, [serviceProviderId, filteredLocationId, id, dates, filteredUserId, reportsFilters]);

  return { data: milestoneFunnelGraphData, loading };
};

export { useMilestoneFunnelGraph };
